// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1.71875 2H13.2803L12.0133 7.06818L12.339 10H21.9995V22H16V16H14V22H1.92555L2.99071 7.08782L1.71875 2ZM10.3267 10L10.1045 8H4.93065L4.0735 20H7.99953V10H10.3267ZM4.2803 4L4.7803 6H10.2188L10.7188 4H4.2803Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chimney-1-filled')
export default class Chimney1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chimney-1-filled',
    }
  }
}
